<template>
    <div class="card" style="border: 0; padding-top: 50px;">
        <div class="row">
            <aside class="col-sm-5 border-right">
                <div class="slider" style="display: flex; flex-wrap: wrap;">
                    <VueSlickCarousel class="slider-nav" ref="c1" :swipe="false" :draggable="false" :asNavFor="$refs.c2" :vertical="true" :slidesToShow="15" :slidesToScroll="1" :arrows="false" :focusOnSelect="true">
                        <div v-for="image in this.product.images" class="slick-slide">
                            <img :src="axios.defaults.baseImageURL +'v1c_files/'+ image" />
                        </div>
                    </VueSlickCarousel>
                    <VueSlickCarousel class="slider-for" ref="c2" :asNavFor="$refs.c1" :slidesToShow="1" :arrows="false">
                        <div v-for="image in this.product.images" class="slick-slide">
                            <img :src="axios.defaults.baseImageURL +'v1c_files/'+ image" />
                        </div>
                    </VueSlickCarousel>
                </div>

                <div class="quantity">
                    <div class="count">
                        <button v-if="product.quantity > 0" @click="minus" class="minus">
                            <i class="fa fa-minus-circle" aria-hidden="true"></i>
                        </button>
                        <input type="text" @keydown="checkProduct()" class="count_value" v-if="product.quantity"
                            :value="product.quantity" name="count">
                        <input v-else class="count_value" value="0">
                        <button @click="plus" class="plus"><i class="fa fa-plus-circle" aria-hidden="true"></i></button>
                    </div>
                    <div class="remain"></div>
                </div>
            </aside>
            <aside class="col-sm-7">
                <article class="card-body p-5">
                    <h3 class="title mb-3">{{ product.name }}</h3>

                    <p class="price-detail-wrap">
                        <span class="price h3" style="color: #3ca053">
                            <span class="currency"></span><span class="num">{{ new
                            Intl.NumberFormat('ru-RU').format(product.price) }} ₸</span>
                        </span>
                    </p> <!-- price-detail-wrap .// -->
                    <dl class="item-property">
                        <dt>Характеристики</dt>
                        <br>
                        <dd style="white-space: pre-wrap" v-html="product.desc"></dd>
                    </dl>
                </article>
            </aside>
        </div>
    </div>

</template>

<script>
import { mapActions } from "vuex";

import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
    name: "ProductPage",
    components: { VueSlickCarousel },

    data() {
        return {
            product: [],
            loading: false,
        }
    },

    mounted() {
        this.loading = true
        this.axios
            .get(this.axios.defaults.baseURL + 'products/' + this.$route.params.alias)
            .then(response => {
                this.getProductWithBasketAction({ product: response.data.item }).then(response => {
                    this.product = response
                    this.product.images = JSON.parse(response.images)
                })

            })
            .catch(error => {
                console.log(error);
            }).finally(() => {
                this.loading = false;
            });
    },

    methods: {
        ...mapActions({
            checkProductAction: 'checkProduct',
            getProductWithBasketAction: 'pushProductWithBasket',
        }),

        slideChange: function () {
            this.thumbsSwiper.activeIndex = this.mySwiper.activeIndex;
        },

        minus: function () {
            if (this.product.quantity > 0) {
                this.product.quantity--;
                this.checkProduct();
            }
        },

        plus: function () {
            this.product.quantity++;
            this.checkProduct()
        },

        checkProduct: function () {
            this.checkProductAction({
                'id': this.product.id,
                'v1c_id': this.product.v1c_id,
                'alias': this.product.alias,
                'quantity': this.product.quantity,
                'price': this.product.price,
                'remain': this.product.remain,
                'vendor_code': this.product.vendor_code,
                'name': this.product.name,
                'image': this.product.image,
            })
        },
    },

    filters: {
        chunk: function (x) {
            var parts = x.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            return parts.join(".");
        },
    },
}
</script>

<style scoped lang="scss">
.slick-slide {
    display: flex;
    justify-content: center;
    position: relative;

    img {
        max-width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
        margin: 0 auto;
    }
}

.slider-for {
    width: calc(100% - 74px);
    height: 500px;
    position: relative;
    overflow-y: visible;
}

.quantity {
    width: 100%;

    .count {
        position: relative;
        width: 125px;
        margin: 0 auto;

        display: flex;
        justify-content: center;
        align-items: center;

        .count_value {
            width: 50px;
            padding: 5px;
            margin: 0 10px;
            text-align: center;
            border: 0;
            background-color: transparent;
        }

        button {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);

            background-color: transparent;
            border: 0;
            cursor: pointer;

            i {
                font-size: 22px;
            }

            &.minus {
                left: 0;
            }

            &.plus {
                right: 0;

                i {
                    &::before {
                        color: green;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/app/pages/ProductPage.vue